module.exports = __webpack_public_path__ + "img/Retailing_1200x800.b415e568.png";